import { createContext, useContext } from 'react';

const ConfigContext = createContext({});

export const useConfig = (): Record<string, string> => {
    const context = useContext(ConfigContext);
    if (context === undefined) {
        throw new Error('No Provider for ConfigContext is found in a parent component');
    }

    return context;
};

export const ConfigProvider = ({ config, children }) => <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
